import { GameSearch } from "./components/GameSearch";

export default GameSearch;
